import { useState, useEffect } from 'react';
import { RolesApi } from '@/api/clients/roles/roles.api';

export const useGetFacilityPermissionSchema = () => {
  const [facilityPermissionSchema, setFacilityPermissionSchema] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFacilityPermissionSchema = async () => {
      setLoading(true);
      setError(null);

      try {
        const { data } = await RolesApi.getFacilityPermissionSchema();
        setFacilityPermissionSchema(data);
      } catch (err) {
        setError(
          err.response?.data?.message ||
            'Failed to fetch facility permission schema',
        );
        console.error('Error fetching facility permission schema:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchFacilityPermissionSchema();
  }, []);

  return {
    facilityPermissionSchema,
    loading,
    error,
  };
};
